import { render, staticRenderFns } from "./MenuSidebarFlippedFilled.vue?vue&type=template&id=b03ba1f8"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports